// import { Field } from '@kanda-libs/ks-component-ts';
import { Field } from '@kanda-libs/ks-component-ts';

import useAddressManual from './useAddressManual';

const AddressManual: React.FunctionComponent = function () {
  const {
    show,
    widgets: Widgets,
    buildingValidation,
    postcodeValidation,
    title,
    onPostcodeBlur,
    fieldNames,
    employmentClass,
  } = useAddressManual();
  if (!show) return null;
  return (
    <>
      <p className="text-14-22-em text-neutral-800 mb-1">{title}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-4">
        <Widgets.BuildingNumber
          validation={buildingValidation}
          placeholder="Building number"
          name={
            employmentClass === 'secondary'
              ? fieldNames.building_number
              : undefined
          }
        />
        <Widgets.BuildingName
          validation={buildingValidation}
          placeholder="Building name"
          name={
            employmentClass === 'secondary'
              ? fieldNames.building_name
              : undefined
          }
        />
        <Widgets.Line1
          className="md:col-span-2"
          label="Line 1"
          placeholder="Line 1"
          name={employmentClass === 'secondary' ? fieldNames.line1 : undefined}
        />
        <Widgets.Line2
          className="md:col-span-2"
          label="Line 2 (optional)"
          placeholder="Line 2"
          name={employmentClass === 'secondary' ? fieldNames.line2 : undefined}
        />
        <Widgets.City
          label="City or Town"
          placeholder="City"
          name={employmentClass === 'secondary' ? fieldNames.city : undefined}
        />
        <Field.Validator validation={postcodeValidation}>
          <Field.Input
            name={fieldNames.postcode}
            label="Postcode"
            placeholder="Postcode"
            onBlur={onPostcodeBlur}
          />
        </Field.Validator>
        <Widgets.County
          label="County (optional)"
          placeholder="County"
          name={employmentClass === 'secondary' ? fieldNames.county : undefined}
        />
        <Widgets.Country
          placeholder="Country"
          name={
            employmentClass === 'secondary' ? fieldNames.country : undefined
          }
        />
      </div>
    </>
  );
};

export default AddressManual;
